import { render, staticRenderFns } from "./OrdersProfile.vue?vue&type=template&id=81f36526&scoped=true"
import script from "./OrdersProfile.vue?vue&type=script&lang=ts"
export * from "./OrdersProfile.vue?vue&type=script&lang=ts"
import style0 from "./OrdersProfile.vue?vue&type=style&index=0&id=81f36526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f36526",
  null
  
)

export default component.exports